export type RoomTemperatureResponse = {
  apartmentCrmId: string;
  measurements: TemperatureMeasurement[];
}[];

export interface TemperatureMeasurement {
  timestamp: string;
  value: number;
}

export enum CLIMATE_TYPES {
  TEMPERATURE = 'TEMPERATURE',
  HUMIDITY = 'HUMIDITY',
  BOTH = 'BOTH',
}
